import React from 'react'
import AltRouteOutlined from '@mui/icons-material/AltRouteOutlined'
import AssignmentTurnedInOutlined from '@mui/icons-material/AssignmentTurnedInOutlined'
import LocationOnOutlined from '@mui/icons-material/LocationOnOutlined'
import TrendingUpOutlined from '@mui/icons-material/TrendingUpOutlined'
import { countUniqueClients } from '../../../helpers/utils'
import { formatLastActivity } from './reportMobileUserCardUtils'

const iconSize = { fontSize: 20 }

export function buildReportPosUserMobileCardSections(model) {
  const userName = model.user_name ?? '—'
  const visited = model.total_visited_clients_count ?? 0
  const attended = model.total_attended_clients_count ?? 0
  const visitasStr = `${visited}/${attended}`
  const lastAct = formatLastActivity(model.pos_task_activity_last_visit)

  const summaryRows = [
    { label: 'Usuario', value: userName, valueTitle: userName },
    { label: 'Última actividad', value: lastAct, valueTitle: lastAct },
    { label: 'Visitas realizadas', value: visitasStr, valueTitle: visitasStr }
  ]

  const geo = `${model.pos_task_activity_location_effective_count ?? 0}/${model.pos_task_activity_location_available_count ?? 0}`
  const tasks = `${model.pos_task_activity_done_task_codes_count ?? 0}/${model.pos_task_activity_total_clients_count ?? 0}`

  const detailRows = [
    {
      icon: <AltRouteOutlined sx={iconSize} />,
      label: 'Visitas fuera de ruta',
      value: String(countUniqueClients(model.out_route_clients)),
      boldValue: true,
      valueTitle: String(countUniqueClients(model.out_route_clients))
    },
    {
      icon: <TrendingUpOutlined sx={iconSize} />,
      label: 'Efectividad',
      value: `${model.pos_task_activity_percent_effectiveness ?? 0}%`,
      boldValue: true,
      valueTitle: `${model.pos_task_activity_percent_effectiveness ?? 0}%`
    },
    {
      icon: <LocationOnOutlined sx={iconSize} />,
      label: 'Actividades en geocerca',
      value: geo,
      boldValue: true,
      valueTitle: geo
    },
    {
      icon: <AssignmentTurnedInOutlined sx={iconSize} />,
      label: 'Tareas en sitio',
      value: tasks,
      boldValue: true,
      valueTitle: tasks
    }
  ]

  return { summaryRows, detailRows }
}
